import React, {memo} from "react";
import { PAYMENT_STATUS } from "../../types/enums";
import { Transaction } from "../../providers/transactions.store";
import successfullMarker from "../../assets/images/successfullMarker.png";
import { MdPendingActions } from "react-icons/md";
import { BiSolidError } from "react-icons/bi";
import {TransactionStatusProps} from "../transactionStatus/transactionStatus.component";

interface TransactionIconProps {
    transaction: Transaction;
}
// export const getTransactionIcon = memo((transaction: TransactionStatusProps['transaction']) => {
//     const {transaction_type, network_provider, status: payment_status} = transaction!;
//
//     if (payment_status === PAYMENT_STATUS.SUCCESS) {
//         return <img width={60} height={60} src={successfullMarker} alt="Transaction successful"/>;
//     }
//
//     if (payment_status === PAYMENT_STATUS.INITIATED || payment_status === PAYMENT_STATUS.PENDING) {
//         return (
//             <div className="size-[60px] bg-yellow-300 d-flex align-items-center justify-content-center rounded-full">
//                 <MdPendingActions color="#eab308" className="size-[30px]"/>
//             </div>
//         );
//     }
//
//     return (
//         <div className="size-[60px] bg-red-300 d-flex align-items-center justify-content-center rounded-full">
//             <BiSolidError color="#ef4444" className="size-[30px]"/>
//         </div>
//     );
// });

export const TransactionIcon: React.FC<TransactionIconProps> = ({ transaction }) => {
    const { status: payment_status } = transaction;

    if (payment_status === PAYMENT_STATUS.SUCCESS) {
        return <img width={60} height={60} src={successfullMarker} alt="Transaction successful" />;
    }

    if (payment_status === PAYMENT_STATUS.INITIATED || payment_status === PAYMENT_STATUS.PENDING) {
        return (
            <div className="size-[60px] bg-yellow-300 d-flex align-items-center justify-content-center rounded-full">
                <MdPendingActions color="#eab308" className="size-[30px]" />
            </div>
        );
    }

    return (
        <div className="size-[60px] bg-red-300 d-flex align-items-center justify-content-center rounded-full">
            <BiSolidError color="#ef4444" className="size-[30px]" />
        </div>
    );
};